module.exports = __webpack_public_path__ + "img/svg/logo.5f042e1d27c3e56663bc8a4a5de544f0.svg";